__webpack_require__.p = "/restore-sync-button-2kb55w3/onboarding/";